module.exports = __webpack_public_path__ + "img/synapse-homepage22.6b581408.png";